import React, { useState } from 'react'
import styles from './ProductTableLine.module.scss'
import { icons } from 'assets'
import sizes from '../products-table-sizes.module.scss'
import moment from 'moment'
import { Tag, IconButton, Picture, WarningMessage } from 'components'
import { inject } from 'mobx-react'
import { PRODUCT_STORE, GENERAL_STORE } from 'store'
import { getMainImageSrcForObj } from 'utilities'
import { Props } from './types'
import { AttributeTypes } from 'models'

const ProductTableLine = (props: Props) => {
  const {
    product,
    [PRODUCT_STORE]: { loadProductDetails },
    [GENERAL_STORE]: { push }
  } = props
  const [expanded, setExpanded] = useState(false)

  const handleOnTitleClick = () => {
    const areProductDetailsLoaded = !!product.productSkus
    !areProductDetailsLoaded && loadProductDetails(product.id, true)
    setExpanded(!expanded)
  }

  return (
    <>
      <div className={styles.tableRow}>
        <h4
          onClick={handleOnTitleClick}
          title={product.name}
          style={expanded
            ? {
              borderLeft: `1px solid ${styles.orange}`,
              paddingLeft: 9
            }
            : {}}
        >
          <IconButton
            icon={expanded ? icons.minus : icons.plus}
          />
          <Picture
            src={getMainImageSrcForObj(product)}
            size={35}
            className={styles.productPicture}
          />
          <span>{product.name}</span>
          <span className={styles.skuNumber}>({product.numberSkus})</span>

          <WarningMessage
            object={product}
            objectType='product'
          />

        </h4>

        <div style={{ width: sizes.brandWidth }}>
          {product.brandName}
        </div>

        <div style={{ width: sizes.dateWidth }}>
          {moment(product.createdDate).format('HH:mm, DD.MM.YYYY')}
        </div>

        <div style={{ width: sizes.tagsWidth }}>
          {product.tags && product.tags.split(',').map((tag, index) =>
            <Tag key={index} tag={tag} />
          )}
        </div>

        <div className={styles.buttonsContainer}>
          <IconButton
            icon={icons.pen}
            title='Edit product'
            className={styles.optionButton}
            onClick={() => push(`/products/edit/${product.id}`)}
          />
        </div>
      </div>

      {
        expanded &&
        <div className={styles.skusContainer}>
          <div>
            <div className={styles.skusTableHeader}>
              <div>SKU</div>
              <div>Description</div>
              <div>Stock</div>
              <div>Price</div>
            </div>

            {
              product.productSkus && product.productSkus.map(sku =>
                <div
                  key={sku.id}
                  className={styles.skuLine}
                >

                  <div>{sku.sku}</div>
                  <div>
                    {sku.attributes && sku.attributes.map(attribute =>
                      <div
                        key={attribute.id}
                        className={styles.optionIndicator}
                      >
                        {attribute.attributeName}:
                        {attribute.type === AttributeTypes.COLOR
                          ? <span style={{ background: attribute.value }} />
                          : ' '
                        }
                        {attribute.name}
                      </div>
                    )}
                  </div>
                  <div>{sku.stock}</div>
                  <div>{sku.price} {sku.curr}</div>

                </div>
              )
            }

          </div>
        </div>
      }

    </>
  )
}

export default inject(PRODUCT_STORE, GENERAL_STORE)(ProductTableLine)
